import React, { useState } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '@/lib/auth';
import { toast } from 'sonner';
import { AUTH } from '@/constants/testIds';

const Signup = () => {
  const { signup, loginWithGoogle } = useAuth();
  const nav = useNavigate();
  const loc = useLocation();
  const next = new URLSearchParams(loc.search).get('next') || '/dashboard';
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await signup(name, email, password);
      toast.success('Account created');
      nav(next, { replace: true });
    } catch (err) {
      toast.error(err?.response?.data?.detail || 'Sign up failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-[calc(100vh-5rem)] bg-sans_bone flex items-center">
      <div className="sans-container grid md:grid-cols-2 gap-16 items-center py-16">
        <div className="hidden md:block">
          <div className="sans-label mb-6">Saans Ayurved</div>
          <h1 className="sans-h2">Begin your Ayurvedic<br/>journey — thoughtfully.</h1>
          <p className="sans-body mt-6 max-w-md">Create your account to take the free Prakriti Assessment and book consultations.</p>
        </div>
        <div className="max-w-md w-full mx-auto md:mx-0">
          <div className="sans-label mb-3">Create account</div>
          <h2 className="font-serif text-3xl text-sans_ink">Join Saans Ayurved</h2>

          <button
            type="button"
            data-testid={AUTH.googleBtn}
            onClick={loginWithGoogle}
            className="sans-btn-secondary w-full mt-8 gap-3"
          >
            <svg width="16" height="16" viewBox="0 0 24 24" aria-hidden="true"><path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.75h3.57c2.08-1.92 3.28-4.74 3.28-8.07z"/><path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.75c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84A11 11 0 0 0 12 23z"/><path fill="#FBBC05" d="M5.84 14.12c-.22-.66-.35-1.36-.35-2.12s.13-1.46.35-2.12V7.04H2.18A11 11 0 0 0 1 12c0 1.77.42 3.45 1.18 4.96l3.66-2.84z"/><path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.04l3.66 2.84C6.71 7.31 9.14 5.38 12 5.38z"/></svg>
            Continue with Google
          </button>

          <div className="flex items-center gap-4 my-8">
            <div className="flex-1 h-px bg-sans_line" />
            <span className="text-[11px] tracking-[0.22em] uppercase text-sans_mute">or</span>
            <div className="flex-1 h-px bg-sans_line" />
          </div>

          <form onSubmit={submit} className="space-y-6">
            <div>
              <label className="sans-label block mb-2">Name</label>
              <input data-testid={AUTH.nameInput} className="sans-input" required value={name} onChange={(e) => setName(e.target.value)} placeholder="Your name" />
            </div>
            <div>
              <label className="sans-label block mb-2">Email</label>
              <input data-testid={AUTH.emailInput} className="sans-input" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="you@example.com" />
            </div>
            <div>
              <label className="sans-label block mb-2">Password</label>
              <input data-testid={AUTH.passwordInput} className="sans-input" type="password" minLength={6} required value={password} onChange={(e) => setPassword(e.target.value)} placeholder="Minimum 6 characters" />
            </div>
            <button data-testid={AUTH.submitBtn} disabled={loading} className="sans-btn-primary w-full">
              {loading ? 'Creating…' : 'Create account'}
            </button>
          </form>

          <div className="mt-8 text-sm text-sans_mute">
            Already have an account?{' '}
            <Link to="/login" data-testid={AUTH.toggleLink} className="sans-link">Sign in</Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Signup;
